import type { BaseTableRow, TableCell } from './types'

import type { ComputedRef, MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'

export const useFilteredCells = <TR extends BaseTableRow>(
  row: MaybeRefOrGetter<TR>,
  ignoredColumns: MaybeRefOrGetter<string[]> = []
): {
  filteredCells: ComputedRef<TableCell[]>
} => {
  const filteredCells = computed(() => {
    const effectiveRow = toValue(row)
    const ignoredCols = toValue(ignoredColumns)

    return Object.keys(effectiveRow).reduce((cells, key) => {
      if (ignoredCols.includes(key)) {
        return cells
      }

      cells.push({
        key,
        value: effectiveRow[key as keyof TR],
      })

      return cells
    }, [] as TableCell[])
  })

  return {
    filteredCells,
  }
}
